module.exports = __webpack_public_path__ + "img/OnSpécifique lumière extérieur.95df536e.gif";